import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { from, Observable, of } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { DataService } from "../services/data.service";
import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class InitResolver {

    constructor(private dataService: DataService, private authService: AuthService){}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.authService.getAccessToken().pipe(
            switchMap(() => from(this.dataService.init())),
            catchError(() => of(null))
        );
    }
}
